<template>
  <div class="baseEdit">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('statementsAdd.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <slip-base-form ref="baseForm" :canEdit="canEdit" />
        </div>
      </el-collapse-item>
      <div class="batchBtns" v-if="canEdit">
        <el-button class="saveBtn" type="primary" @click="importAssociation()">{{
          $t('statementsAdd.buttons.importSettlementBtn')
        }}</el-button>
      </div>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('statementsAdd.collapseTitle.costTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <cost-detail ref="costDetail" :canEdit="canEdit" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('statementsAdd.collapseTitle.detailTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs class="batchTabs" type="border-card">
            <!-- 采购合同明细 -->
            <el-tab-pane :label="$t('statementsAdd.tabsName.procurement')">
              <procurement ref="procurement" />
            </el-tab-pane>
            <!-- 销售明细 -->
            <el-tab-pane :label="$t('statementsAdd.tabsName.salesContract')">
              <sales-contract ref="salesContract" />
            </el-tab-pane>
            <!-- 收款明细 -->
            <el-tab-pane :label="$t('statementsAdd.tabsName.collection')">
              <collection ref="collection" />
            </el-tab-pane>
            <!-- 付款明细 -->
            <el-tab-pane :label="$t('statementsAdd.tabsName.payment')">
              <payment ref="payment" />
            </el-tab-pane>
            <!-- 费用明细 -->
            <el-tab-pane :label="$t('statementsAdd.tabsName.cost')">
              <cost ref="cost" />
            </el-tab-pane>
            <!-- 资金利息 -->
            <el-tab-pane :label="$t('statementsAdd.tabsName.fundsInterests')">
              <funds-interests :settleNo="settleNo" ref="fundsInterests" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-if="this.$route.name.indexOf('Detail') != -1"
        type="primary"
        v-hasPermi="['2021050811231792426']"
        @click="canEdit = !canEdit"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.editToggle') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050811230619171']"
        :disabled="!canEdit"
        type="primary"
        @click="save()"
        class="fixed-bottom-btn"
        >{{ this.$t('transportOrderAdd.btnList.save') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/settle';
  import slipBaseForm from './components/baseForm'; // 基本信息
  import CostDetail from './components/costDetail'; // 基本信息
  import Procurement from './components/procurement'; // 采购合同明细
  import Payment from './components/payment'; // 付款明细
  import SalesContract from './components/salesContract'; // 销售明细
  import Collection from './components/collection'; // 收款明细
  import Cost from './components/cost'; // 费用明细
  import FundsInterests from './components/fundsInterests'; // 资金利息
  export default {
    name: 'baseEdit',
    components: {
      slipBaseForm,
      CostDetail,
      Procurement,
      Payment,
      SalesContract,
      Collection,
      Cost,
      FundsInterests,
    },
    data() {
      return {
        canEdit: true,
        settleNo: null,
        activeNames: ['1', '2', '3'],
        componentsList: [
          { componentKey: 'procurement', dataKey: 'purchaseContractDetailList' },
          { componentKey: 'salesContract', dataKey: 'salesContractDetailList' },
          { componentKey: 'payment', dataKey: 'fundPaymentList' },
          { componentKey: 'collection', dataKey: 'fundCollectionList' },
          { componentKey: 'cost', dataKey: 'expenseDetailList' },
          { componentKey: 'fundsInterests', dataKey: 'fundInterestList' },
        ],
      };
    },
    mounted() {
      if (this.$route.name.indexOf('Detail') != -1) {
        this.canEdit = false;
      }
      if (this.$route.name.indexOf('Add') == -1) {
        this.getData();
      }
    },
    methods: {
      async getData() {
        // 获取详情数据
        this.loading.startLoading();
        let res = await this.$axios.post(API.GET_ORDER_SETTLE_SLIP, { id: this.$route.query.id });
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.settleNo = res.data.data.settleNo;
            this.$refs.baseForm.getDetail(res.data.data);
            this.importDetail(res.data.data);
          }
        }
      },
      importAssociation() {
        let settleNo = this.$refs.baseForm.baseData.settleNo;
        if (!settleNo) return this.tips('settleNoMsg', 'error');
        this.loading.startLoading();
        this.$axios.post(API.GET_IMPORT_DATA, { settleNo }).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.settleNo = res.data.data.settleNo;
            this.importDetail(res.data.data);
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      importDetail(detail) {
        this.$refs.costDetail.importDetail(detail); // 费用信息
        this.componentsList.map((item) => {
          let tableData = [];
          let detailItem = detail[item.dataKey];
          if (detailItem) {
            detailItem.map((it) => {
              it.serializationJsonData = JSON.parse(it.serializationJsonData);
            });
            tableData = detailItem;
          }
          this.$refs[item.componentKey].tableData = tableData;
        });
      },
      save() {
        let baseData = this.$refs.baseForm.exportChildData();
        if (baseData) {
          if (this.settleNo != baseData.settleNo) {
            return this.tips('noImport', 'error');
          }
          let costDetail = this.$refs.costDetail.exportChildData();
          let params = { ...baseData, ...costDetail };
          let orderSettleSlipAssociationList = [];
          this.componentsList.map((item) => {
            this.$refs[item.componentKey].exportChildData().map((it, idx) => {
              let itemData = {
                ...it,
                settleSlipNo: baseData.slipNo,
                settleSlipDetailNo: idx + 1,
                invoiceQuantity: it.invoiceQuantity,
                invoiceAmount: it.invoiceAmount,
                serializationJsonData: JSON.stringify(it.serializationJsonData),
              };
              orderSettleSlipAssociationList.push(itemData);
            });
          });
          params.orderSettleSlipAssociationList = orderSettleSlipAssociationList;
          params = this.$baseRequest.assignObj(params);
          this.loading.startLoading();
          this.$axios.post(API.SAVE_ORDER_SETTLE_SLIP, params).then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.returnPath();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        }
      },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`statementsAdd.msg.${info}`),
          type: type,
        });
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/settle/statementsList',
            name: 'statementsList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .batchBtns {
    margin-bottom: 10px;
  }
</style>
